import { render, staticRenderFns } from "./AdminSpecialistMenu.vue?vue&type=template&id=4218527b"
import script from "./AdminSpecialistMenu.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports